import { Typography } from "antd";
import styled from "styled-components";

export const CodeBlock = styled(Typography.Paragraph)`
  background-color: #f5f5f5;
  font-family: monospace;
  white-space: pre;
  padding: 1em;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  overflow-x: auto;
`;
